import React from 'react';
import PropTypes from 'prop-types';

import Tabs from '@molecules/Tabs';
import { BodyLarge, H4 } from '@styled';
import SearchSavedContacts from '../../../searches/SearchSavedContacts';

// Functionality
import { useScheduleAppointmentModal } from '../../../modals/ScheduleAppointmentModal';
import SearchEventAttendees from '../../../searches/SearchEventAttendees';

const timeSlotDuration = 30;

const TrusteeEventAttendees = ({ event }) => {
    const { event_code: eventCode } = event;
    const { openModal: openScheduleAppointmentModal } = useScheduleAppointmentModal({ event, timeSlotDuration });

    return (
        <div>
            <H4 className="mb-1.5rem">Connect With Attendees</H4>

            <Tabs defaultActiveTab="attendees">
                <div tabKey="attendees" title="Attendees">
                    <BodyLarge className="mb-2rem">Explore fellow event attendees</BodyLarge>
                    <SearchEventAttendees
                        eventCode={eventCode}
                        hitsPerPage={6}
                        openScheduleAppointmentModal={openScheduleAppointmentModal}
                        showPagingToolbar
                    />
                </div>

                <div tabKey="saved" title="Saved Contacts">
                    <SearchSavedContacts
                        additionalFilters={`events_attended.code:${eventCode}`}
                        includeInactive
                        parentView="Events"
                        onCalendarClick={openScheduleAppointmentModal}
                        NoResultsText={() => (
                            <>
                                Looks like you have no saved contacts attending the event. Browse the attendee list and
                                save contacts.
                            </>
                        )}
                    />
                </div>
            </Tabs>
        </div>
    );
};

TrusteeEventAttendees.propTypes = {
    event: PropTypes.shape({
        event_code: PropTypes.string.isRequired,
        meeting_start_time: PropTypes.instanceOf(Date),
        meeting_end_time: PropTypes.instanceOf(Date),
    }).isRequired,
};

export default TrusteeEventAttendees;
